import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.task.dataset');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review-task-dataset',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.task.dataset/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #27312c;
  background: #f4f6f3;
}

* {
  box-sizing: border-box;
}

.reviewer-dataset-page {
  min-height: 100vh;
  background: #f4f6f3;
}

.dataset-page-header__inner,
.dataset-workspace {
  width: min(1440px, 100%);
  margin: 0 auto;
  border: 1px solid #dfe5e1;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(41, 58, 49, 0.05);
}

.dataset-back {
  position: absolute;
  top: 20px;
  left: 32px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #cbd9d2;
  border-radius: 8px;
  color: #356957;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.dataset-back:hover,
.dataset-back:focus-visible {
  color: #fff;
  background: #2f6f59;
  outline: 0;
}

.dataset-page-heading {
  min-width: 0;
  padding-top: 38px;
}

.dataset-eyebrow {
  margin: 0;
  color: #d35e3b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.dataset-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 7px;
}

.dataset-title-row h1 {
  margin: 0;
}

.dataset-title-row > span,
.dataset-card__readonly {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border-radius: 999px;
  color: #47725f;
  background: #edf5f0;
  font-size: 12px;
  font-weight: 700;
}

.dataset-page-heading > p:last-child {
  margin: 10px 0 0;
  color: #7b847f;
  font-size: 12px;
  font-weight: 600;
}

.dataset-count {
  min-width: 138px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: end;
  gap: 1px 5px;
  padding: 18px 20px;
  border-radius: 12px;
  color: #fff;
  background: #285b4b;
}

.dataset-count small {
  grid-column: 1/-1;
  color: #bdd2c9;
  font-size: 12px;
  font-weight: 700;
}

.dataset-count strong {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.dataset-count span {
  font-size: 12px;
  font-weight: 700;
}

.dataset-state {
  width: min(1440px, 100%);
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  margin: 0 auto;
  border: 1px solid #dfe5e1;
  border-radius: 14px;
  color: #69736d;
  background: #fff;
}

.dataset-state > i {
  color: #34715c;
  font-size: 24px;
}

.dataset-state.is-error > i {
  color: #dc5a35;
}

.dataset-state strong {
  font-size: 14px;
}

.dataset-state p {
  margin: 0;
  font-size: 12px;
}

.dataset-state button {
  min-height: 36px;
  padding: 0 15px;
  border: 0;
  color: #fff;
  background: #2f6f59;
  cursor: pointer;
}

.dataset-workspace {
  overflow: hidden;
}

.dataset-workspace__header {
  min-height: 112px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 22px 28px;
  border-bottom: 1px solid #e3e8e5;
}

.dataset-workspace__header h2 {
  margin: 5px 0 0;
  color: #27312c;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.dataset-workspace__header > div:first-child > p:last-child {
  margin: 6px 0 0;
  color: #838b87;
  font-size: 12px;
}

.dataset-workspace__meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.dataset-workspace__meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #dce4df;
  border-radius: 8px;
  color: #5b6861;
  background: #fafbfa;
  font-size: 12px;
  font-weight: 700;
}

.dataset-list {
  display: grid;
  gap: 14px;
  margin: 0;
  padding: 18px;
  list-style: none;
  background: #f7f9f7;
}

.dataset-card {
  overflow: hidden;
  border: 1px solid #dce4df;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 7px 18px rgba(44, 62, 52, 0.04);
}

.dataset-card__header {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 15px;
  border-bottom: 1px solid #e5e9e6;
}

.dataset-card__identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dataset-card__identity > span {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 9px;
  color: #fff;
  background: #2f705b;
  font-size: 12px;
  font-weight: 700;
}

.dataset-card__identity > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.dataset-card__identity strong {
  overflow: hidden;
  color: #303a34;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-card__identity small {
  overflow: hidden;
  color: #7e8882;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-card__qa {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dataset-card__qa section {
  min-width: 0;
  display: flex;
  gap: 12px;
  padding: 18px;
}

.dataset-card__qa section + section {
  border-left: 1px solid #e5e9e6;
}

.dataset-card__qa section > span {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
}

.dataset-question > span {
  color: #2c725b;
  background: #edf6f1;
}

.dataset-answer > span {
  color: #b65a39;
  background: #fbefe9;
}

.dataset-card__qa small,
.dataset-card__qa h3,
.dataset-card__qa p {
  display: block;
  margin: 0;
}

.dataset-card__qa small {
  color: #939b96;
  font-size: 12px;
  font-weight: 700;
}

.dataset-card__qa h3,
.dataset-card__qa p {
  margin-top: 7px;
  color: #364039;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.7;
  white-space: pre-wrap;
}

.dataset-evidence {
  margin: 0;
  padding: 14px 18px 18px;
  border-top: 1px solid #e5e9e6;
  background: #fbfaf6;
}

.dataset-evidence figcaption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.dataset-evidence figcaption span {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #59675f;
}

.dataset-evidence figcaption i {
  color: #2f705b;
}

.dataset-evidence figcaption strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dataset-evidence figcaption em {
  color: #8c948f;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.dataset-evidence > div {
  margin-top: 10px;
  padding: 13px 15px;
  border-left: 3px solid #6e9982;
  border-radius: 0 8px 8px 0;
  background: #f2f7f3;
}

.dataset-evidence > div > strong {
  color: #51705f;
  font-size: 12px;
  font-weight: 700;
}

.dataset-evidence blockquote {
  margin: 7px 0 0;
  color: #4b5750;
  font-size: 12px;
  line-height: 1.75;
  white-space: pre-wrap;
}

.dataset-pagination {
  min-height: 66px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 18px;
  border-top: 1px solid #e2e7e4;
}

.dataset-pagination p {
  margin: 0;
  color: #8a928d;
  font-size: 12px;
}

.dataset-pagination p strong {
  color: #356957;
}

.dataset-pagination nav {
  display: flex;
  gap: 6px;
}

.dataset-pagination button {
  width: 34px;
  height: 34px;
  border: 1px solid #dce3df;
  color: #69746d;
  background: #fff;
  cursor: pointer;
}

.dataset-pagination button.is-active {
  color: #fff;
  border-color: #2f705b;
  background: #2f705b;
}

.dataset-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.dataset-empty {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 7px;
  color: #89928d;
}

.dataset-empty i {
  margin-bottom: 4px;
  font-size: 24px;
}

.dataset-empty strong {
  color: #59655e;
  font-size: 13px;
}

.dataset-empty p {
  margin: 0;
  font-size: 12px;
}

@media (max-width: 900px) {
  .dataset-back {
    left: 24px;
  }
  .dataset-count {
    min-width: 0;
    grid-template-columns: auto auto 1fr;
    align-items: center;
  }
  .dataset-count small {
    grid-column: auto;
  }
  .dataset-count strong {
    font-size: 20px;
  }
  .dataset-workspace__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-workspace__meta {
    justify-content: flex-start;
  }
  .dataset-card__qa {
    grid-template-columns: minmax(0, 1fr);
  }
  .dataset-card__qa section + section {
    border-top: 1px solid #e5e9e6;
    border-left: 0;
  }
}
@media (max-width: 560px) {
  .dataset-title-row {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-card__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-card__readonly {
    margin-left: 44px;
  }
  .dataset-pagination {
    align-items: flex-start;
    flex-direction: column;
  }
  .dataset-pagination nav {
    max-width: 100%;
    overflow-x: auto;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-workspace {
  padding: 16px;
}
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-card {
  border: 1px solid var(--ro-line);
  border-radius: 12px;
  box-shadow: none;
}
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-card__header {
  flex-wrap: wrap;
  gap: 12px;
}
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-card__identity {
  min-width: 0;
}
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-card__identity strong {
  white-space: normal;
  overflow-wrap: anywhere;
}
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-evidence blockquote {
  font-size: 16px;
  line-height: 28px;
}
:host-context(.reviewops-shell) .reviewer-dataset-page .dataset-pagination {
  flex-wrap: wrap;
  gap: 16px;
}`],
})
export class PageReviewTaskDatasetComponent implements OnInit {
    public taskId: string = '';
    public task: any = {};
    public items: any[] = [];
    public loading: boolean = true;
    public loadError: string = '';
    public page: number = 1;
    public pageSize: number = 10;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.taskId = String(WizRoute.segment.id || '');
        await this.loadDataset();
        await this.service.render();
    }

    public reviewRoute() {
        return '/review-tasks/qa/' + this.taskId;
    }

    public pagedItems() {
        const offset = (this.page - 1) * this.pageSize;
        return this.items.slice(offset, offset + this.pageSize);
    }

    public pageCount() {
        return Math.max(1, Math.ceil(this.items.length / this.pageSize));
    }

    public pageNumbers() {
        return Array.from({ length: this.pageCount() }, (_value, index) => index + 1);
    }

    public async setPage(page: number) {
        this.page = Math.min(this.pageCount(), Math.max(1, page));
        await this.service.render();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public rangeStart() {
        return this.items.length ? (this.page - 1) * this.pageSize + 1 : 0;
    }

    public rangeEnd() {
        return Math.min(this.items.length, this.page * this.pageSize);
    }

    public sourceTitle(item: any) {
        const source = item && item.source;
        if (typeof source === 'string') return source;
        return String(source && (source.title || source.document_title || source.document_id) || '자료함 원문');
    }

    public sourceDetail(item: any) {
        const source = item && item.source;
        if (!source || typeof source !== 'object') return '';
        return [
            source.version ? 'v' + source.version : '',
            source.page ? source.page + '쪽' : ''
        ].filter((value: string) => !!value).join(' · ');
    }

    private async loadDataset() {
        this.loading = true;
        this.loadError = '';
        try {
            const statePayload = await this.fetchJson('/api/v1/review-workspace/state');
            const state = this.unwrapState(statePayload);
            if (!state) throw new Error('검수 작업 정보를 불러오지 못했습니다.');
            const tasks: any[] = Array.isArray(state.tasks)
                ? state.tasks
                : Object.values(state.tasks || {}) as any[];
            const sourceTask: any = tasks.find((item: any) => String(item && item.id || '') === this.taskId);
            if (!sourceTask || String(sourceTask.kind || '').toLowerCase() !== 'qa') {
                throw new Error('배정된 QA 검수 작업을 찾을 수 없습니다.');
            }
            this.task = this.normalizeTask(sourceTask);
            const samples = Array.isArray(sourceTask.samples) ? sourceTask.samples : [];
            const fullCount = Number(sourceTask.fullQaCount ?? sourceTask.qaCount ?? samples.length) || samples.length;
            if (samples.length > 0 && samples.length === fullCount) {
                this.items = samples.map((item: any, index: number) => this.normalizeItem(item, index));
            } else {
                const datasetPayload = await this.fetchJson(
                    '/api/v1/review-workspace/state?qa_dataset_task_id=' + encodeURIComponent(this.taskId)
                );
                const dataset = this.unwrapDataset(datasetPayload);
                if (!dataset || !Array.isArray(dataset.items)) {
                    throw new Error('전체 QA 데이터셋 응답 형식이 올바르지 않습니다.');
                }
                this.items = dataset.items.map((item: any, index: number) => this.normalizeItem(item, index));
            }
            this.page = 1;
        } catch (error) {
            this.task = {};
            this.items = [];
            this.loadError = error instanceof Error ? error.message : '전체 QA 데이터셋을 불러오지 못했습니다.';
        }
        this.loading = false;
    }

    public async reload() {
        await this.loadDataset();
        await this.service.render();
    }

    private normalizeTask(task: any) {
        return {
            id: String(task.id || this.taskId),
            title: String(task.projectName || task.project || task.dataset || 'QA 검수 프로젝트'),
            harnessVersion: String(task.harnessVersion || task.harness_version || '현재 하네스'),
            survey: String(task.survey || task.surveyName || '검수 설문지'),
            surveyVersion: String(task.surveyVersion || task.survey_version || '')
        };
    }

    private normalizeItem(item: any, index: number) {
        const source = item && item.source;
        const answer = item && item.answer;
        const evidence = item && item.evidence;
        return Object.assign({}, item, {
            id: String(item && item.id || 'QA-' + String(index + 1).padStart(4, '0')),
            question: String(item && item.question || ''),
            answer: typeof answer === 'object' && answer ? String(answer.text || '') : String(answer || ''),
            evidence: typeof evidence === 'object' && evidence ? String(evidence.quote || evidence.text || '') : String(evidence || ''),
            source: source || '자료함 원문',
            meta: String(item && (item.meta || item.metadata_label || item.risk) || '')
        });
    }

    private async fetchJson(url: string) {
        const response = await fetch(url, {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store'
        });
        let payload: any = {};
        try {
            payload = await response.json();
        } catch (error) { }
        const code = Number(payload && payload.code);
        if (!response.ok || (Number.isFinite(code) && code >= 400)) {
            throw new Error(String(payload?.message || payload?.data?.message || '요청을 처리하지 못했습니다.'));
        }
        return payload;
    }

    private unwrapState(payload: any) {
        const candidates = [
            payload?.data?.data?.state, payload?.data?.state, payload?.data?.data,
            payload?.result?.state, payload?.state, payload?.result, payload?.data, payload
        ];
        return candidates.find((candidate: any) => candidate && typeof candidate === 'object'
            && (candidate.tasks !== undefined || candidate.schema_version !== undefined)) || null;
    }

    private unwrapDataset(payload: any) {
        const queue: any[] = [payload];
        const visited = new Set<any>();
        for (let cursor = 0; cursor < queue.length && cursor < 32; cursor += 1) {
            let candidate = queue[cursor];
            if (typeof candidate === 'string') {
                try { candidate = JSON.parse(candidate); } catch (error) { continue; }
            }
            if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate) || visited.has(candidate)) continue;
            visited.add(candidate);
            if (Array.isArray(candidate.items)) return candidate;
            for (const key of ['data', 'result', 'dataset', 'qa_set', 'artifact', 'payload']) {
                if (candidate[key] !== undefined && candidate[key] !== null) queue.push(candidate[key]);
            }
        }
        return null;
    }
}

export default PageReviewTaskDatasetComponent;